"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencySelector = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireWildcard(require("react"));
var _InputWithIcon = require("../../elements/input-with-icon/InputWithIcon");
var _Option = require("../../elements/option/Option");
var _Paper = require("../../elements/paper/Paper");
var _Divider = require("../../elements/divider/Divider");
var _chevronDown = require("../../assets/icons/chevron-down.svg");
var _currencySelectorModule = _interopRequireDefault(require("./currency-selector.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ButtonWithIcon = require("../button-components/button-with-icon/ButtonWithIcon");
var _useCurrencies = _interopRequireDefault(require("./hooks/useCurrencies"));
var _noop = require("../../utils/noop");
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _excluded = ["value", "popularCurrencies", "allowedCurrencies", "className", "disabled", "onChange", "data-testid", "id", "asSuffix", "small", "name", "error", "hidePopularCurrencies"];
var defaultPopularCurrencies = ['EUR', 'GBP', 'USD'];
var CurrencySelector = function CurrencySelector(_ref) {
  var value = _ref.value,
    _ref$popularCurrencie = _ref.popularCurrencies,
    popularCurrencies = _ref$popularCurrencie === void 0 ? defaultPopularCurrencies : _ref$popularCurrencie,
    allowedCurrencies = _ref.allowedCurrencies,
    className = _ref.className,
    disabled = _ref.disabled,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _noop.noop : _ref$onChange,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'currencySelector' : _ref$dataTestid,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'currency-selector' : _ref$id,
    _ref$asSuffix = _ref.asSuffix,
    asSuffix = _ref$asSuffix === void 0 ? false : _ref$asSuffix,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    name = _ref.name,
    error = _ref.error,
    hidePopularCurrencies = _ref.hidePopularCurrencies,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    currencyFilter = _useState4[0],
    setCurrencyFilter = _useState4[1];
  var listRef = (0, _react.useRef)(null);
  var buttonRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var currencies = (0, _useCurrencies.default)(popularCurrencies, allowedCurrencies, hidePopularCurrencies);
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var handleClick = (0, _react.useCallback)(function () {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  }, []);
  var filterCurrencies = (0, _react.useCallback)(function (currencyList) {
    return currencyList.filter(function (currency) {
      return currency.value.toLocaleLowerCase().includes(currencyFilter.toLocaleLowerCase()) || currency.label.toLocaleLowerCase().includes(currencyFilter.toLocaleLowerCase());
    });
  }, [currencyFilter]);
  var handleClickOutside = (0, _react.useCallback)(function (e) {
    var _buttonRef$current, _listRef$current;
    /* istanbul ignore else */
    if (isOpen && !((_buttonRef$current = buttonRef.current) !== null && _buttonRef$current !== void 0 && _buttonRef$current.contains(e.target)) && !((_listRef$current = listRef.current) !== null && _listRef$current !== void 0 && _listRef$current.contains(e.target))) {
      setIsOpen(false);
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);
  var handleChange = function handleChange(value) {
    onChange(value);
    setIsOpen(false);
  };
  var renderButton = function renderButton() {
    if (asSuffix || small) {
      return /*#__PURE__*/_react.default.createElement(_ButtonWithIcon.NeutralButtonWithIcon, {
        suffixIcon: /*#__PURE__*/_react.default.createElement(_chevronDown.ReactComponent, {
          className: (0, _classnames.default)(_currencySelectorModule.default['currency-selector__button__icon'])
        }),
        className: (0, _classnames.default)(asSuffix && _currencySelectorModule.default['currency-selector__button'], isOpen && asSuffix && _currencySelectorModule.default['currency-selector__button--focused'], small && _currencySelectorModule.default['currency-selector__dropdown'], small && _currencySelectorModule.default['currency-selector__dropdown--small'], isOpen && small && _currencySelectorModule.default['currency-selector__dropdown--focused']),
        onClick: handleClick,
        innerRef: buttonRef,
        disabled: disabled,
        "data-testid": "".concat(dataTestId, ".button")
      }, value);
    } else {
      return /*#__PURE__*/_react.default.createElement(_ButtonWithIcon.NeutralButtonWithIcon, {
        innerRef: buttonRef,
        disabled: disabled,
        prefixIcon: /*#__PURE__*/_react.default.createElement("p", {
          className: _currencySelectorModule.default['currency-selector__prefix']
        }, value),
        suffixIcon: /*#__PURE__*/_react.default.createElement(_chevronDown.ReactComponent, {
          className: (0, _classnames.default)(_currencySelectorModule.default['currency-selector__button__icon'])
        }),
        className: (0, _classnames.default)(_currencySelectorModule.default['currency-selector__dropdown'], isOpen && _currencySelectorModule.default['currency-selector__dropdown--focused'], error && _currencySelectorModule.default['currency-selector__dropdown--error'], disabled && _currencySelectorModule.default['currency-selector__dropdown--disabled']),
        onClick: handleClick,
        "data-testid": "".concat(dataTestId, ".dropdown")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: _currencySelectorModule.default['currency-selector__currency'],
        "data-testid": "".concat(dataTestId, ".button")
      }, value && t("currencies.".concat(value))));
    }
  };
  var renderDropdown = function renderDropdown() {
    return /*#__PURE__*/_react.default.createElement(_Paper.Paper, {
      "data-testid": "".concat(dataTestId, ".container"),
      className: (0, _classnames.default)(_currencySelectorModule.default['currency-selector__container'], (0, _defineProperty2.default)({}, _currencySelectorModule.default['currency-selector__container--floating'], !asSuffix)),
      ref: listRef
    }, /*#__PURE__*/_react.default.createElement(_InputWithIcon.SearchInput, {
      className: _currencySelectorModule.default[''],
      "data-testid": "".concat(dataTestId, ".search"),
      id: "".concat(id, ".search"),
      name: "currency-selector-search",
      placeholder: "Type to search\u2026",
      ref: inputRef,
      onChange: function onChange(event) {
        return setCurrencyFilter(event.currentTarget.value);
      },
      value: currencyFilter
    }), Object.entries(currencies).map(function (currencyType) {
      var isPopular = currencyType[0] === 'popular';
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: currencyType[0]
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: (0, _classnames.default)(_currencySelectorModule.default['currency-selector__list'], isPopular && _currencySelectorModule.default['currency-selector__list--fixed'])
      }, filterCurrencies(currencyType[1]).map(function (option) {
        return /*#__PURE__*/_react.default.createElement(_Option.Option, {
          key: option.value,
          selected: option.value === value,
          className: _currencySelectorModule.default['currency-selector__option'],
          onClick: function onClick() {
            handleChange(option.value);
            setIsOpen(false);
          }
        }, option.label);
      })), isPopular && !hidePopularCurrencies && /*#__PURE__*/_react.default.createElement(_Divider.Divider, {
        className: _currencySelectorModule.default['currency-selector__divider']
      }));
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({
    className: (0, _classnames.default)(_currencySelectorModule.default['currency-selector'], isOpen && _currencySelectorModule.default['currency-selector--open'], asSuffix && _currencySelectorModule.default['currency-selector--inline'], className),
    id: id,
    "data-testid": dataTestId
  }, rest), renderButton(), isOpen && renderDropdown());
};
exports.CurrencySelector = CurrencySelector;